import { createSelector } from 'reselect';

export const selectAutenticacionState = (state) => state.autenticacion.autenticacion;
export const selectEstadosState = (state) => state.autenticacion.estados;
export const selectIndicadoresState = (state) => state.autenticacion.indicadores;
export const selectCaptchaState = (state) => state.autenticacion.captcha;
export const selectMenuSistemasState = (state) => state.autenticacion.menuSistemas;
export const selectCerrarSesionState = (state) => state.autenticacion.cerrarSesion;

export const isLogged = createSelector(
  selectAutenticacionState,
  (autenticacionState) => autenticacionState.data?.active
);
